<template>
  <div class="connect-page">
    <div v-if="getAvailableSmartwatches.length === 0">
      <title-component>
        Er zijn op dit moment geen smartwatches beschikbaar om uit te geven
      </title-component>
      <p>Zorg ervoor dat er een smartwatch is aangemeld</p>
    </div>
    <ul>
      <listitem-component
        v-for="smartwatch in getAvailableSmartwatches"
        :key="smartwatch.id"
        @click.native="connectSmartwatch(smartwatch.id)"
      >{{ smartwatch.smartwatchName }}</listitem-component>
    </ul>
  </div>
</template>

<script>
import TitleComponent from '../components/title.component';
import ListitemComponent from '../components/listitem.component';
import { mapGetters } from 'vuex';
import { RouteName, Viewport } from '../utils/enums';

export default {
  name: 'connect-page',
  components: {
    ListitemComponent,
    TitleComponent
  },
  computed: {
    ...mapGetters(['getAvailableSmartwatches']),
    isTitleVisible() {
      return this.$mq !== Viewport.DESKTOP;
    }
  },
  methods: {
    connectSmartwatch(smartwatchId) {
      this.$store.commit('SET_SMARTWATCH_TO_CONNECT', smartwatchId);
      this.$router.push({ name: RouteName.CONNECT_CLIENT });
    }
  },
  created() {
    this.$store.dispatch('FETCH_ALL_AVAILABLE_SMARTWATCHES');
  }
};
</script>
<style scoped lang="scss">
.listitem-component::v-deep {
  .listitem-icon {
    background-image: url('../assets/icons/watch-large-white.svg');
  }
}
</style>
